module.exports = __webpack_public_path__ + "img/Menu-04.2a8ae402.png";